import type {ReactElement} from 'react'
// Styles
import styles from '../client-landing-page.module.scss'
// Types
import type {BallotPageBlock} from '../../types/ballot'

interface TitleBlockProps {
  block: BallotPageBlock
}

const TitleBlock = ({block}: TitleBlockProps): ReactElement | null => {
  const title = block.formValuesObject.blockTitle

  if (!title) return null

  return <h1 className={styles['__title']}>{title}</h1>
}

export default TitleBlock
